'use strict';

var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
require('react');
var _taggedTemplateLiteral = require('@babel/runtime/helpers/taggedTemplateLiteral');
var styled = require('@emotion/styled');
var react = require('@emotion/react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var _taggedTemplateLiteral__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteral);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var getArrowPosition = function getArrowPosition(alignment, size) {
  return {
    center: '50%',
    start: "calc(".concat(size, " * 2)"),
    end: 'calc(100% - 16px)'
  }[alignment];
};
var ArrowStyled = styled__default["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral__default["default"](["\n    --arrowColor: ", ";\n\n    border-bottom: ", " solid transparent;\n    border-left: ", " solid transparent;\n    border-right: ", " solid transparent;\n    border-top: ", " solid transparent;\n    height: 0;\n    position: absolute;\n    width: 0;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors['background-brand-tooltip'];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space['10'];
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space['10'];
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.space['10'];
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.space['10'];
});
var ArrowBottomStyled = styled__default["default"](ArrowStyled)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral__default["default"](["\n    border-bottom: ", " solid var(--arrowColor);\n    border-top: none;\n    left: ", ";\n    top: -9px;\n    transform: translate(-50%, 0);\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return theme.space['10'];
}, function (_ref7) {
  var alignment = _ref7.alignment,
    theme = _ref7.theme;
  return getArrowPosition(alignment, theme.space['10']);
});
var ArrowTopStyled = styled__default["default"](ArrowStyled)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral__default["default"](["\n    border-bottom: none;\n    border-top: ", " solid var(--arrowColor);\n    bottom: -9px;\n    left: ", ";\n    transform: translate(-50%, 0);\n"])), function (_ref8) {
  var theme = _ref8.theme;
  return theme.space['10'];
}, function (_ref9) {
  var alignment = _ref9.alignment,
    theme = _ref9.theme;
  return getArrowPosition(alignment, theme.space['10']);
});
var ArrowLeftStyled = styled__default["default"](ArrowStyled)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral__default["default"](["\n    border-left: ", " solid var(--arrowColor);\n    border-right: none;\n    right: -", ";\n    top: ", ";\n    transform: translate(0, -50%);\n"])), function (_ref10) {
  var theme = _ref10.theme;
  return theme.space['10'];
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.space['10'];
}, function (_ref12) {
  var alignment = _ref12.alignment,
    theme = _ref12.theme;
  return getArrowPosition(alignment, theme.space['10']);
});
var ArrowRightStyled = styled__default["default"](ArrowStyled)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral__default["default"](["\n    border-left: none;\n    border-right: ", " solid var(--arrowColor);\n    left: -", ";\n    top: ", ";\n    transform: translate(0, -50%);\n"])), function (_ref13) {
  var theme = _ref13.theme;
  return theme.space['10'];
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.space['8'];
}, function (_ref15) {
  var alignment = _ref15.alignment,
    theme = _ref15.theme;
  return getArrowPosition(alignment, theme.space['10']);
});

var Arrow = function Arrow(_ref) {
  var className = _ref.className,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? '' : _ref$placement,
    _ref$isPopoverArrow = _ref.isPopoverArrow,
    isPopoverArrow = _ref$isPopoverArrow === void 0 ? false : _ref$isPopoverArrow;
  var _placement$split = placement.split('-'),
    _placement$split2 = _slicedToArray__default["default"](_placement$split, 2),
    position = _placement$split2[0],
    _placement$split2$ = _placement$split2[1],
    alignment = _placement$split2$ === void 0 ? 'center' : _placement$split2$;
  var arrowProps = {
    className: className,
    alignment: alignment,
    'data-popper-arrow': isPopoverArrow
  };
  switch (position) {
    case 'bottom':
      {
        return react.jsx(ArrowBottomStyled, arrowProps);
      }
    case 'top':
      {
        return react.jsx(ArrowTopStyled, arrowProps);
      }
    case 'left':
      {
        return react.jsx(ArrowLeftStyled, arrowProps);
      }
    case 'right':
      {
        return react.jsx(ArrowRightStyled, arrowProps);
      }
    default:
      {
        return null;
      }
  }
};

exports.Arrow = Arrow;
//# sourceMappingURL=Arrow-86d218a7.js.map
